import React from 'react';
import { 
    Box, 
    Typography, 
    Paper
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import VoiceRecorder from '../../../components/shared/VoiceRecorder';
import GroceryDragLayout from './GroceryDragLayout';

const ActiveGroceryList = ({ items, loading, onCheck, onDelete, onAddItem, currentUserId, onVoiceTranscription, validationType = 'grocery' }) => {
    const { enqueueSnackbar } = useSnackbar();

    // New "Add Item" button component that matches list item styling
    const AddItemButton = () => (
        <Paper
            elevation={4}
            sx={{
                p: 3,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                borderRadius: 3,
                bgcolor: '#ffffff',
                border: '2px dashed #cbd5e0', // Dashed border to distinguish as an action
                minHeight: 100,
                cursor: 'pointer', // Pointer cursor
                transition: 'all 0.2s',
                '&:hover': {
                    bgcolor: '#f7fafc',
                    borderColor: '#3182ce',
                    transform: 'translateY(-2px)',
                    boxShadow: 6
                }
            }}
        >
             <Box 
                sx={{ 
                    width: 40, 
                    height: 40, 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    borderRadius: '50%',
                    bgcolor: '#ebf8ff'
                }}
            >
                <AddIcon sx={{ fontSize: 30, color: '#3182ce' }} />
            </Box>

            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: '#4a5568', // Slightly lighter than item text
                }}
            >
                Tap to Add Item
            </Typography>
        </Paper>
    );

    const handleDragDrop = (itemId, dropZoneId) => {
        const item = items.find(i => i.id === itemId);
        if (!item) return;

        if (dropZoneId === 'fridge') {
            // Mark as purchased
            onCheck(itemId, currentUserId);
            enqueueSnackbar(`${item.name} purchased! 🎉`, { 
                variant: 'success',
                autoHideDuration: 3000
            });
        } else if (dropZoneId === 'trash') {
            // Delete (confirmation handled by layout if configured, but here we just do logic)
            onDelete(itemId);
            enqueueSnackbar(`${item.name} deleted`, { 
                variant: 'error',
                autoHideDuration: 2000
            });
        }
    };

    const emptyState = (
        <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography variant="h5" color="white" fontWeight="bold">
                No items in the list
            </Typography>
        </Box>
    );

    const dropZones = [
        {
            id: 'fridge',
            label: 'PURCHASED',
            color: '#2f855a',
            hoverColor: '#48bb78'
        },
        {
            id: 'trash',
            label: 'DELETE',
            color: '#c53030',
            hoverColor: '#f56565'
        }
    ];

    return (
        <GroceryDragLayout
            items={items}
            loading={loading}
            currentUserId={currentUserId}
            dropZones={dropZones}
            onDragDrop={handleDragDrop}
            emptyState={emptyState}
        >
            <VoiceRecorder
                onTranscription={onVoiceTranscription}
                currentUserId={currentUserId}
                validationType={validationType}
            >
                <AddItemButton />
            </VoiceRecorder>
        </GroceryDragLayout>
    );
};

export default ActiveGroceryList;
